export const chartHeatmapBase = {
  data: {
    labels: [],
    datasets: []
  },
  options: {
    stroke: false,
    responsive: false,
    showLabels: false,
    //labelScale: 0.35,
    labelScale: 0,
    labelFontColor: 'black',
    rounded: false,
    /*roundedRadius: 0.1,*/
    /*paddingScale: 0.02,*/
    paddingScale: 0,
    colorInterpolation: 'palette',
    tooltipTemplate: '<%= xLabel %> | <%= yLabel %>',
    //tooltipTemplate: '',
    //colorHighlight: true,
    //colorHighlightMultiplier: 0.92,
    colorHighlight: false,
    colorHighlightMultiplier: 1,
    colors: ['#cf0224', '#a5154a', '#7c2871', '#523c97', '#294fbe', '#0063e5']
  }
}

export default chartHeatmapBase;
